module.exports = __webpack_public_path__ + "img/stock.8c509fb5.png";